import React, {
    useEffect,
    useState,
    useCallback,
} from 'react';
import PropTypes from 'prop-types';
import {
    disableBodyScroll,
    clearAllBodyScrollLocks,
} from 'body-scroll-lock';
import classNames from 'classnames';

import { Mobile, Desktop } from 'app/components/Responsive';
import XBig from 'app/assets/svg/x_big.component.svg';

import Close from './close.component.svg';
import CloseWhite from './close-white.component.svg';


import './modal-slider.scss';


export function ModalSingle(props) {
    const {
        onClickClose,
        transitionState,
        title,
        children,
        dialogType,
    } = props;

    const [scrollContentRef, setScrollContainerRef] = useState(null);

    useEffect(() => {
        if (transitionState === 'exited') {
            clearAllBodyScrollLocks();
            setScrollContainerRef(null);
        } else if (scrollContentRef) {
            disableBodyScroll(scrollContentRef);
        }
    }, [transitionState, scrollContentRef]);

    const setRef = useCallback((current) => {
        setScrollContainerRef(current);
    }, []);

    const isOpen = transitionState !== 'exited';


    const modalClasses = classNames({
        modal: true,
        'modal--single': true,
        [transitionState]: transitionState,
    });

    const modalWrapClasses = classNames({
        'modal-wrap': true,
        'modal-wrap--single': true,
        [transitionState]: transitionState,
        'modal-wrap--small': dialogType === 'SMALL_MODAL',
    });

    const modalWrapInner = classNames({
        'modal-wrap-inner': true,
        'modal-wrap-inner--without-title': !title,
    });

    const modalContentClasses = classNames({
        'modal-content': true,
        [transitionState]: transitionState,
        'modal-content--small': true,
    });

    const modalHeaderTextClasses = classNames({
        'modal-header__text': true,
        'modal-header__text--small': dialogType === 'SMALL_MODAL',
    });

    const closeButtonSpecificClasses = classNames({
        'modal-close--small': dialogType === 'SMALL_MODAL',
        'modal-close--big': dialogType !== 'SMALL_MODAL',
    });

    return (
        <div styleName={modalClasses}>
            <Desktop>
                <div styleName="modal-silder-arrows">
                    <button
                        type="button"
                        onClick={onClickClose}
                        styleName="modal-close-bg"
                    />
                </div>
            </Desktop>

            <div styleName={modalWrapClasses}>
                <div styleName={modalWrapInner}>
                    {title && (
                        <div styleName="modal-header">
                            <p styleName={modalHeaderTextClasses}>
                                {title}
                            </p>
                        </div>
                    )}
                    <button
                        type="button"
                        onClick={onClickClose}
                        styleName="modal-close modal-close--without-title"
                    >
                        <CloseWhite />
                    </button>
                    <div styleName={modalContentClasses}>
                        <button
                            type="button"
                            onClick={onClickClose}
                            styleName={closeButtonSpecificClasses}
                        >
                            <Close />
                        </button>

                        <div
                            styleName="modal-content-content"
                        >
                            {isOpen && children({ setRef })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ModalSingle.propTypes = {
    onClickClose: PropTypes.func.isRequired,
};
